import { render } from "./ApplicationNotFound.vue?vue&type=template&id=215ef202&scoped=true"
import script from "./ApplicationNotFound.vue?vue&type=script&lang=js"
export * from "./ApplicationNotFound.vue?vue&type=script&lang=js"

import "./ApplicationNotFound.vue?vue&type=style&index=0&id=215ef202&lang=scss&scoped=true"

import exportComponent from "/app/tmp/notjusttravel/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215ef202"]])

export default __exports__